import { Button } from "../../Button";
import { Typo } from "../../Typo";
import { useRebateTierTranslatedContent } from "../useRebateTierTranslatedContent";

type SectionErrorProps = {
  onRetry: () => void;
  "data-testid"?: string;
  retryTestId?: string;
};

export const SectionError = ({
  onRetry,
  "data-testid": testId,
  retryTestId,
}: SectionErrorProps) => {
  const content = useRebateTierTranslatedContent();

  return (
    <div
      role="alert"
      data-testid={testId}
      className="flex flex-col items-center gap-4 rounded-xl bg-surface-secondary p-6 text-center"
    >
      <div className="flex flex-col gap-2">
        <Typo
          element="p"
          smType="labelSM"
          lgType="labelMD"
          textColor="text-text-primary"
        >
          {content.sectionErrorTitle}
        </Typo>
        <Typo
          element="p"
          smType="bodyXS"
          lgType="bodySM"
          textColor="text-text-secondary"
        >
          {content.sectionErrorBody}
        </Typo>
      </div>
      <Button
        variant="brand"
        size="sm"
        onClick={onRetry}
        data-testid={retryTestId}
      >
        {content.sectionErrorRetry}
      </Button>
    </div>
  );
};
